import { forwardRef, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Modal } from '@/components/common/Modal/Modal';

import DeliveryDetails from '../DeliveryDetails/DeliveryDetails';
import PostcodeEntry from '../PostcodeEntry/PostcodeEntry';

export type Ref = HTMLDivElement | null;

const CheckIfWeDeliverModal = forwardRef<any | null>((_, ref) => {
  const [showModal, setShowModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showCheckIfWeDeliverModal(): void {
      setShowModal(true);
    },
  }));

  const { register } = useForm();
  const [isShownDeliveryComp, setIsShownDeliveryComp] = useState(false);

  const [postalData, setPostalData] = useState<any>([]);

  const handleClick = (props: any) => {
    setIsShownDeliveryComp((current) => !current);
    setPostalData(props);
  };

  const customContentStyles = {
    width: 'fit-content',
    minWidth: 300,
    maxHeight: '90%',
    overflow: 'initial',
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={() => setShowModal(false)}
      headerTitle={''}
      customContentStyles={customContentStyles}
    >
      {!isShownDeliveryComp && (
        <div className={`h-[262px] w-[300px] pt-7 md:h-[282px] md:w-[380px]`}>
          <PostcodeEntry
            register={register}
            handleClick={handleClick}
            isDeliveryPopup={true}
            label="Postcode"
            placeholder="Eg. 2000"
          />
        </div>
      )}
      {isShownDeliveryComp && (
        <div>
          <DeliveryDetails
            postalData={postalData}
            isDeliveryPopup={true}
            setShowModal={setShowModal}
          />
        </div>
      )}
    </Modal>
  );
});

CheckIfWeDeliverModal.displayName = 'CheckIfWeDeliverModal';

export default CheckIfWeDeliverModal;
